document.addEventListener('DOMContentLoaded', function () {
    // Encontra todos os contêineres de abas na página.
    const tabContainers = document.querySelectorAll('.wp-block-wpmundi-tabs');

    tabContainers.forEach(container => {
        // Encontra os botões de navegação e os painéis de conteúdo dentro do contêiner.
        const tabsNav = container.querySelector('.wpmundi-tabs-nav');
        if (!tabsNav) return;
        
        const tabButtons = tabsNav.querySelectorAll('.wp-block-button');
        const tabPanels = container.querySelectorAll('.wpmundi-tab-panel');

        // Adiciona um ouvinte de evento de clique a cada botão de aba.
        tabButtons.forEach((button, index) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();

                // Remove a classe 'is-active' de todos os botões e painéis.
                tabButtons.forEach(btn => btn.classList.remove('is-active'));
                tabPanels.forEach(panel => panel.classList.remove('is-active'));

                // Adiciona a classe 'is-active' apenas ao botão e painel clicados.
                button.classList.add('is-active');
                if (tabPanels[index]) {
                    tabPanels[index].classList.add('is-active');
                }
            });
        });
    });
});